export default __webpack_public_path__ + "static/media/img006.d00658df.png";